import brandFonts from './brandFonts';
import getQueryStringValue from './getQueryStringValue';
import { stateName, stateUf } from './stateName';
import { getPageFromUrl } from './getPageFromUrl';
import isUfValid from './isUfValid';
import queryToString from './queryToString';
import convertCurrency from './convertCurrency';
import getUserId from './getUserId';
import { startDownloadFile } from './startDownloadFile';
import { isEudoraSpc } from './eudora/eudoraHelper';
import { getCatalogUrl } from './getCatalogUrl';
import {
  getIPaperUrl,
  getConfigCatValue,
} from './getConfigCatValue/getConfigCatValue';
import { injectUTMParamsInUrl } from './injectUTMParamsInUrl';

export {
  stateName,
  stateUf,
  injectUTMParamsInUrl,
  brandFonts,
  getQueryStringValue,
  getPageFromUrl,
  getConfigCatValue,
  isUfValid,
  queryToString,
  convertCurrency,
  getUserId,
  startDownloadFile,
  isEudoraSpc,
  getIPaperUrl,
  getCatalogUrl,
};
